import { ValueOf } from '../utilities/types';

const anomalyDeviationDirections = {
  HIGHER: 'higher',
  LOWER: 'lower',
  BOTH: 'both',
} as const;

export const anomalyDeviationDirectionChoices = [
  { id: anomalyDeviationDirections.BOTH, name: 'Both' },
  { id: anomalyDeviationDirections.LOWER, name: 'Lower Only' },
  { id: anomalyDeviationDirections.HIGHER, name: 'Higher Only' },
];

export type AnomalyDeviationDirection = ValueOf<typeof anomalyDeviationDirections>;

export default anomalyDeviationDirections;
